import { makeActionCreator } from '../../../utilities'
import { EKGImportConstants } from './ekgImport.constants'

export const getPowerOnTimeListResults = makeActionCreator(EKGImportConstants.GET_POWER_ON_TIME_LIST_RESULTS)
export const setPowerOnTimeListResults = makeActionCreator(
  EKGImportConstants.SET_POWER_ON_TIME_LIST_RESULTS,
  'powerOnTimeList'
)
export const setSelectedPowerOnTime = makeActionCreator(
  EKGImportConstants.SET_SELECTED_POWER_ON_TIME,
  'selectedPowerOnTime'
)
export const setFromTimeOptions = makeActionCreator(EKGImportConstants.SET_FROM_TIME_OPTIONS, 'fromTimeOptions')

export const setFilteredFrom = makeActionCreator(EKGImportConstants.SET_FILTERED_FROM, 'filteredFrom')
export const getFilteredFrom = makeActionCreator(EKGImportConstants.GET_FILTERED_FROM)

export const setFilteredMonitor = makeActionCreator(EKGImportConstants.SET_FILTERED_MONITOR, 'filteredMonitor')
export const getFilteredMonitor = makeActionCreator(EKGImportConstants.GET_FILTERED_MONITOR)

export const getEventsAndReportsResults = makeActionCreator(EKGImportConstants.GET_EVENTS_AND_REPORTS_RESULTS)
export const setEventsListResults = makeActionCreator(EKGImportConstants.SET_EVENTS_LIST_RESULTS, 'eventsList')
export const setReportsListResults = makeActionCreator(EKGImportConstants.SET_REPORTS_LIST_RESULTS, 'reportsList')

export const setSelectedEvents = makeActionCreator(EKGImportConstants.SET_SELECTED_EVENTS, 'selectedEvents')
export const setSelectedReports = makeActionCreator(EKGImportConstants.SET_SELECTED_REPORTS, 'selectedReports')

export const setVisitedReports = makeActionCreator(EKGImportConstants.SET_VISITED_REPORTS, 'visitedReports')
export const getReportImage = makeActionCreator(EKGImportConstants.GET_REPORT_IMAGE, 'reportId')
export const getReportAttachmentImage = makeActionCreator(EKGImportConstants.GET_REPORT_ATTACHMENT_IMAGE, 'reportId')
export const updateReportsList = makeActionCreator(EKGImportConstants.UPDATE_REPORTS_LIST, 'reportsList')

export const setMonitorOptions = makeActionCreator(EKGImportConstants.SET_MONITOR_OPTIONS, 'monitorOptions')

export const saveEkgImportData = makeActionCreator(EKGImportConstants.SAVE_EKG_IMPORT_DATA)
export const getReportAttachments = makeActionCreator(EKGImportConstants.GET_REPORT_ATTACHMENTS)
export const saveReportAttachments = makeActionCreator(EKGImportConstants.SAVE_REPORT_ATTACHMENTS, 'reportAttachments')
export const deleteReportAttachment = makeActionCreator(
  EKGImportConstants.DELETE_REPORT_ATTACHMENT,
  'reportAttachmentToDelete'
)

export const setProcedureEvents = makeActionCreator(EKGImportConstants.SET_PROCEDURE_EVENTS, 'procedureEvents')
export const setCurrentProcedure = makeActionCreator(EKGImportConstants.SET_CURRENT_PROCEDURE, 'currentProcedure')

export const createMedicationProcedure = makeActionCreator(EKGImportConstants.CREATE_MEDICATION_PROCEDURE)
export const createAirwayProcedure = makeActionCreator(EKGImportConstants.CREATE_AIRWAY_PROCEDURE)
export const createCriticalCareProcedure = makeActionCreator(EKGImportConstants.CREATE_CRITICAL_CARE_PROCEDURE)
export const createOperationsProcedure = makeActionCreator(EKGImportConstants.CREATE_OPERATIONS_PROCEDURE)
export const createCardiacProcedure = makeActionCreator(EKGImportConstants.CREATE_CARDIAC_PROCEDURE)
export const createIntubationProcedure = makeActionCreator(EKGImportConstants.CREATE_INTUBATION_PROCEDURE)
export const createDrainProcedure = makeActionCreator(EKGImportConstants.CREATE_DRAIN_PROCEDURE)
export const createHospitalNotifyProcedure = makeActionCreator(EKGImportConstants.CREATE_HOSPITAL_NOTIFY_PROCEDURE)
export const createLabsProcedure = makeActionCreator(EKGImportConstants.CREATE_LABS_PROCEDURE)
export const createVentilatorProcedure = makeActionCreator(EKGImportConstants.CREATE_VENTILATOR_PROCEDURE)
export const createTitrateProcedure = makeActionCreator(EKGImportConstants.CREATE_TITRATE_PROCEDURE)
export const createInitiateIvProcedure = makeActionCreator(EKGImportConstants.CREATE_INITIATE_IV_PROCEDURE)

export const resetEKGAfterFlowCompletes = makeActionCreator(EKGImportConstants.RESET_EKG_AFTER_FLOW_COMPLETES)
export const resetEKGAfterLeavingChart = makeActionCreator(EKGImportConstants.RESET_EKG_AFTER_LEAVING_CHART)
export const resetEKGAfterLeavingService = makeActionCreator(EKGImportConstants.RESET_EKG_AFTER_LEAVING_SERVICE)
